import { PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost2Bubbles = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  const messages = [
    { text: "Gdzie znajdę schronisko w okolicy?", isQuestion: true },
    { text: "📍 Mapa pokaże Ci najbliższe!", isQuestion: false },
    { text: "A jak mogę pomóc?", isQuestion: true },
    { text: "🐕 Spacery, 🎁 dary, 📢 udostępnianie!", isQuestion: false },
    { text: "Skąd wiem, czego potrzebują?", isQuestion: true },
    { text: "🚨 Pilne potrzeby są zawsze na górze!", isQuestion: false },
  ];
  
  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Main content - centered for safe zone */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          padding: "100px",
        }}
      >
        {/* Header */}
        <h1
          style={{
            fontSize: "64px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 40px",
            lineHeight: 1.1,
          }}
        >
          Pytania? Mamy<br />odpowiedzi! 💬
        </h1>

        {/* Chat bubbles */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            width: "100%",
            maxWidth: "820px",
          }}
        >
          {messages.map((msg, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: msg.isQuestion ? "flex-start" : "flex-end",
              }}
            >
              <div
                style={{
                  background: msg.isQuestion 
                    ? "rgba(255,255,255,0.97)" 
                    : "linear-gradient(135deg, #4E8A6E 0%, #3D7A5E 100%)",
                  color: msg.isQuestion ? "#2D5A3D" : "#FFFFFF",
                  borderRadius: msg.isQuestion 
                    ? "24px 24px 24px 6px" 
                    : "24px 24px 6px 24px",
                  padding: "18px 28px",
                  fontSize: "26px",
                  fontWeight: 700,
                  maxWidth: "78%",
                  boxShadow: msg.isQuestion 
                    ? "0 6px 24px rgba(0,0,0,0.06)"
                    : "0 6px 24px rgba(78, 138, 110, 0.25)",
                }}
              >
                {msg.text}
              </div>
            </div>
          ))}
        </div>

        {/* Logo with brand name */}
        <div
          style={{
            marginTop: "56px",
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <PawPrint style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "36px", fontWeight: 800, color: "#2D5A3D" }}>
            GdzieSchronisko
          </span>
        </div>
      </div>
    </GraphicBackground>
  );
};

